import { useState } from "react";
import { TagsInput } from "react-tag-input-component";
import { checkUserPermission } from "../../../../common/UserPermission";

let PERMISSION_DELETE = "delete-attributes";

const AttributeTableRows = ({
  rowsData,
  deleteTableRows,
  handleChange,
  handleChecked,
  handleSubmitRow
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteAttributeId, setDeleteAttributeId] = useState(null);
  const [selectedAttribute, setSelectedAttribute] = useState([]);

  const handleDeleteClick = (attributeId) => {
    setDeleteAttributeId(attributeId);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    deleteTableRows(deleteAttributeId);
    setShowDeleteModal(false);
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
  };

  const handleClose = () => {
    setShowDeleteModal(false);
  };

  if (rowsData != "")
    return rowsData.map((data, index) => {
      const { id, name, values, IsShowEcommerce } = data;
      let splitValue;
      // console.log(values,"values===>>")
      if (values != null || undefined || "") {
        splitValue = values?.split(",");
        console.log(splitValue, "splitValue==>");
        // if(splitValue[0]==""){
        //   splitValue=""
        // }
        if (
          splitValue[0] != "" &&
          splitValue[0] != null &&
          splitValue[0] != undefined
        ) {
          selectedAttribute[index] = splitValue;
        }
      }

      const handleAttributeChange = (evnt) => {
        console.log(evnt, "data444");
        selectedAttribute[index] = evnt;

        handleChange(index, selectedAttribute[index]);
      };

      console.log("splitValue 50", splitValue);

      return (
        <tr 
        // key={index}
        >
          <td className="text-center">
            {id != 0 && (
              <input
                class="form-check-input"
                onChange={(e) => handleChecked(index, id, e.target.checked)}
                type="checkbox"
                role="switch"
                checked={IsShowEcommerce === 1 ? true : false}
              />
            )}
          </td>
          <td className="p-medium">
            <input type="hidden" name="id" value={id} />
            <input
              type="text"
              className="form-control form-control-sm btn-secondary p-medium"
              name="name"
              value={name}
              onChange={(evnt) => handleChange(index, evnt)}
            />
          </td>
          <td>
            <TagsInput
              // value={splitValue}
              value={splitValue}
              className="btn-secondary p-medium"
              onChange={handleAttributeChange}
              placeHolder="Add New Attribute Value + Press Enter"
            />

            <div className="mt-1">
              {(checkUserPermission(PERMISSION_DELETE)  && id != 0) ? (
                // <i
                //   className="fa fa-trash text-red fa-2x"
                //   data-bs-toggle="tooltip"
                //   title="Delete"
                //   onClick={() => handleDeleteClick(index)}
                //   data-bs-backdrop="static"
                //   data-bs-keyboard="false"
                // />

                <button
                data-bs-toggle="tooltip"
                title="Delete"
                onClick={() => handleDeleteClick(id)}
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                type="button"
                className="btn btn-sm btn-primary m-1"
              >
                Delete
              </button>
              ) : (
                ""
              )}

              <button
                type="button"
                className="btn btn-sm btn-primary m-1"
                onClick={(e) => handleSubmitRow(data)}
              >
                Save
              </button>
            </div>

            {/* Delete confirmation modal */}
            <div
              className={`modal ${showDeleteModal ? "d-block" : ""} `}
              tabIndex="-1"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h6 className="card-title">Confirmation</h6>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={handleClose}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-lg-12">
                        <p className="col-form-label p-lg-medium">
                          Are you sure you want to delete this row?
                        </p>
                        <p className="text-danger , fs-7">
                          Note : you require to delete all the item's variations
                          attached with this attribute
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer justify-content-center">
                    {/* {checkUserPermission(PERMISSION_DELETE) ? ( */}
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleConfirmDelete}
                    >
                      Delete
                    </button>
                    {/* ) : (
                      ""
                    )} */}
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleCancelDelete}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );
    });
};

export default AttributeTableRows;
